import { Dispatch } from 'react';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { ContentListAction } from '../../model';
import { ContentListDeletePopup } from '../../ui';

export function useContentListDeletePopup(
	selectedContentIds: number[],
	dispatch: Dispatch<ContentListAction>,
	closeEditMode: () => void,
) {
	const { pushLayer } = useUILayerStore();

	function openContentListDeletePopup() {
		pushLayer(
			'popup',
			<ContentListDeletePopup
				selectedContentIds={selectedContentIds}
				dispatch={dispatch}
				closeEditMode={closeEditMode}
			/>,
		);
	}

	return {
		openContentListDeletePopup,
	};
}
